const ur = {
  nav_dashboard: 'ڈیش بورڈ', nav_inventory: 'انوینٹری', nav_my_stock: 'میرا اسٹاک',
  nav_containers: 'کنٹینرز', nav_requests: 'درخواستیں', nav_invoices: 'انوائسز',
  nav_payments: 'ادائیگیاں', nav_settings: 'سیٹنگز', nav_sign_out: 'لاگ آؤٹ',
  nav_customers: 'گاہک', nav_employees: 'عملہ', nav_tasks: 'کام',
  nav_scan: 'اسکین', nav_pricing: 'قیمتیں', nav_price_quotes: 'کوٹیشن',
  nav_selection_orders: 'انتخاب آرڈرز',
  btn_save: 'محفوظ کریں', btn_cancel: 'منسوخ', btn_delete: 'حذف کریں', btn_edit: 'ترمیم',
  btn_add: 'شامل کریں', btn_submit: 'جمع کرائیں', btn_approve: 'منظور', btn_reject: 'مسترد',
  btn_search: 'تلاش', btn_confirm: 'تصدیق', btn_sign_in: 'لاگ ان',
  btn_save_changes: 'تبدیلیاں محفوظ کریں',
  login_title: 'BIG STAR', login_subtitle: 'گاڑیوں کی برآمد کا انتظام',
  login_username: 'صارف نام', login_email: 'ای میل', login_password: 'پاس ورڈ',
  login_remember: 'مجھے یاد رکھیں', login_invalid: 'غلط معلومات',
  detail_make: 'بنانے والا', detail_model: 'ماڈل', detail_year: 'سال',
  detail_chassis: 'چیسس نمبر', detail_color: 'رنگ', detail_mileage: 'مائلیج',
  detail_condition: 'حالت', detail_status: 'حیثیت', detail_price: 'قیمت',
  status_available: 'دستیاب', status_shipped: 'بھیج دیا گیا',
  status_delivered: 'پہنچا دیا گیا', status_pending: 'زیر التوا',
  vehicles: 'گاڑیاں', engines: 'انجن', parts: 'پرزے', dashboard: 'ڈیش بورڈ',
  add: 'شامل کریں', edit: 'ترمیم', save: 'محفوظ', cancel: 'منسوخ', search: 'تلاش',
  noData: 'کوئی ڈیٹا نہیں', dash_welcome: 'خوش آمدید، {name}',
  dash_total_fob: 'کل FOB قیمت',
  dash_late_night: 'رات بخیر', dash_hello: 'ہیلو',
  dash_subtitle: 'آپ کے بیڑے، پرزوں اور آنے والی شپمنٹس کا جائزہ — ریئل ٹائم میں اپ ڈیٹ۔',
  dash_local_time: 'مقامی وقت', dash_status: 'حیثیت', dash_all_systems_live: 'تمام سسٹمز فعال ہیں',
  dash_view_recommendations: 'سفارشات دیکھیں', dash_my_stock: 'میرا اسٹاک', dash_in_transit: 'راستے میں',
  dash_units: 'یونٹس', dash_containers: 'کنٹینرز', dash_browse_more: 'مزید دیکھیں',
  dash_track_shipments: 'شپمنٹس ٹریک کریں', dash_browse_inventory_start: 'شروع کرنے کے لیے انوینٹری دیکھیں',
  dash_no_active_shipments: 'کوئی فعال شپمنٹ نہیں', dash_next_eta: 'اگلی آمد', dash_days: 'دن',
  dash_etas_confirming: 'آمد کی تاریخیں تصدیق ہو رہی ہیں', dash_this_week: 'اس ہفتے',
  dash_arriving_soon: 'جلد آ رہا ہے', dash_logistics: 'لاجسٹکس', dash_active_shipments: 'فعال شپمنٹس',
  dash_view_all: 'سب دیکھیں', dash_shipment_empty: 'جب یونٹس کنٹینر میں لوڈ ہوں گے تو آپ کی اگلی شپمنٹ یہاں نظر آئے گی',
  dash_composition: 'ساخت', dash_stock_breakdown: 'اسٹاک کی تفصیل', dash_no_units_yet: 'ابھی تک کوئی یونٹ نہیں',
  dash_browse_to_build: 'اپنا اسٹاک بنانے کے لیے انوینٹری دیکھیں',
  dash_for_you: 'آپ کے لیے', dash_picked_based: 'آپ کے اسٹاک کی بنیاد پر منتخب', dash_browse_all: 'سب دیکھیں',
  dash_picking_units: 'ہم آپ کے لیے یونٹس منتخب کر رہے ہیں۔ جلد واپس آئیں یا پوری انوینٹری دیکھیں',
  dash_view_details: 'تفصیلات دیکھیں', dash_just_arrived: 'ابھی آیا', dash_similar: 'آپ کے جیسا',
  dash_today: 'آج', dash_tomorrow: 'کل',
};
export default ur;
